/* BD HERBS — quick add from product cards.
   - Single-variant products: added straight to the cart.
   - Others: a bottom sheet (phones) / popup (desktop) with image, names, price, variant pills and quantity.
   Uses Shopify's Ajax Cart API and Dawn's cart drawer, so the page never reloads. */
(() => {
  const dialog = document.getElementById('BdQuickAdd');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';

  const config = JSON.parse(dialog.querySelector('[data-bd-config]').textContent);
  const labels = config.labels;
  const $ = (selector) => dialog.querySelector(selector);
  const ui = {
    image: $('.bd-sheet__image'),
    title: $('.bd-sheet__title'),
    bn: $('.bd-sheet__bn'),
    priceNow: $('.bd-sheet__price-now'),
    priceWas: $('.bd-sheet__price-was'),
    options: $('[data-options]'),
    qty: $('.bd-qty__input'),
    minus: $('[data-qty="-1"]'),
    plus: $('[data-qty="1"]'),
    error: $('.bd-sheet__error'),
    add: $('[data-bd-add]'),
    addLabel: $('.bd-sheet__add-label'),
    details: $('[data-bd-details]'),
  };

  const productCache = new Map();
  let product = null;
  let variant = null;
  let trigger = null;
  let keepScrollLock = false;

  /* ---------- Helpers ---------- */
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartAddUrl = ((window.routes && window.routes.cart_add_url) || root + 'cart/add') + '.js';

  function formatMoney(cents, format = config.moneyFormat || '{{amount}}') {
    const value = Number(cents) || 0;
    const fmt = (precision, thousands = ',', decimal = '.') => {
      const [whole, frac] = (value / 100).toFixed(precision).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    const pattern = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(pattern);
    if (!match) return fmt(2);
    const map = {
      amount: () => fmt(2),
      amount_no_decimals: () => fmt(0),
      amount_with_comma_separator: () => fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => fmt(0, '.'),
      amount_with_apostrophe_separator: () => fmt(2, "'"),
      amount_no_decimals_with_space_separator: () => fmt(0, ' '),
      amount_with_space_separator: () => fmt(2, ' ', ','),
      amount_with_period_and_space_separator: () => fmt(2, ' ', '.'),
    };
    const formatted = format.replace(pattern, (map[match[1]] || map.amount)());
    return config.bnDigits ? formatted.replace(/\d/g, (d) => '০১২৩৪৫৬৭৮৯'[d]) : formatted;
  }

  function sizedImage(src, width) {
    if (!src) return '';
    const url = src.startsWith('//') ? 'https:' + src : src;
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function setBusy(button, busy) {
    button.classList.toggle('is-loading', busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.disabled = busy || button.dataset.locked === 'true';
  }

  function showError(target, message) {
    if (!target) return;
    target.textContent = message || '';
    target.hidden = !message;
  }

  // Card button confirmation: "✓ যোগ হয়েছে" for a moment, then back to its label
  function flashAdded(button) {
    if (!button || !button.matches('[data-bd-quick-add]')) return;
    const label = button.querySelector('.bd-qa__label');
    if (!label) return;
    clearTimeout(button.bdAddedTimer);
    if (!button.dataset.label) button.dataset.label = label.textContent.trim();
    label.textContent = labels.added;
    button.classList.add('is-added');
    button.bdAddedTimer = setTimeout(() => {
      label.textContent = button.dataset.label;
      button.classList.remove('is-added');
    }, 2400);
  }

  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Product request failed');
    const data = await response.json();
    // Normalise options: newer responses give objects, older ones give names only
    data.options = data.options.map((option, index) =>
      typeof option === 'string'
        ? { name: option, values: [...new Set(data.variants.map((v) => v[`option${index + 1}`]))] }
        : option
    );
    productCache.set(handle, data);
    return data;
  }

  /* ---------- Cart ---------- */
  async function addToCart(variantId, quantity, sourceButton, errorTarget) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { id: Number(variantId), quantity };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(trigger || sourceButton);
    }

    setBusy(sourceButton, true);
    showError(errorTarget, '');
    try {
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (data.status) {
        showError(errorTarget, data.description || data.message || labels.error);
        return false;
      }

      flashAdded(trigger || sourceButton);

      const opensDrawer = Boolean(cart && typeof cart.renderContents === 'function');
      if (dialog.open) {
        keepScrollLock = opensDrawer && cart.tagName === 'CART-DRAWER';
        closeSheet();
      }

      if (opensDrawer) {
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
      }

      // Dawn's pub/sub (constants.js + pubsub.js are classic scripts, so these are global bindings)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'bd-quick-add',
          productVariantId: variantId,
          cartData: data,
        });
      }
      return true;
    } catch (error) {
      console.error(error);
      showError(errorTarget, labels.error);
      return false;
    } finally {
      setBusy(sourceButton, false);
    }
  }

  // Shared helper for other BD components (product page): Ajax add + cart drawer, resolves true on success
  window.BDCart = {
    add(variantId, quantity, button, errorTarget) {
      trigger = button;
      return addToCart(variantId, quantity, button, errorTarget);
    },
  };

  /* ---------- Sheet rendering ---------- */
  function selectedValues() {
    return product.options.map((option, index) => {
      const checked = ui.options.querySelector(`input[name="bd-opt-${index}"]:checked`);
      return checked ? checked.value : null;
    });
  }

  function findVariant(values) {
    return product.variants.find((v) => values.every((value, i) => v[`option${i + 1}`] === value)) || null;
  }

  function renderOptions() {
    ui.options.innerHTML = '';
    if (product.variants.length <= 1 && product.options.length <= 1) return;

    product.options.forEach((option, index) => {
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'bd-pills';
      const legend = document.createElement('legend');
      legend.className = 'bd-sheet__label';
      legend.textContent = option.name;
      fieldset.appendChild(legend);

      const list = document.createElement('div');
      list.className = 'bd-pills__list';
      option.values.forEach((value, valueIndex) => {
        const id = `BdOpt-${index}-${valueIndex}`;
        const input = document.createElement('input');
        input.type = 'radio';
        input.className = 'bd-pills__input visually-hidden';
        input.name = `bd-opt-${index}`;
        input.id = id;
        input.value = value;
        input.checked = variant && variant[`option${index + 1}`] === value;

        const label = document.createElement('label');
        label.className = 'bd-pills__pill';
        label.htmlFor = id;
        label.textContent = value;

        list.append(input, label);
      });
      fieldset.appendChild(list);
      ui.options.appendChild(fieldset);
    });
  }

  // Grey out values that are sold out (or don't exist) together with the other current choices
  function updateAvailability() {
    const values = selectedValues();
    product.options.forEach((option, index) => {
      ui.options.querySelectorAll(`input[name="bd-opt-${index}"]`).forEach((input) => {
        const candidate = [...values];
        candidate[index] = input.value;
        const match = product.variants.find((v) =>
          candidate.every((value, i) => value === null || v[`option${i + 1}`] === value)
        );
        const available = Boolean(match && match.available);
        input.classList.toggle('is-unavailable', !available);

        // Screen readers hear "sold out" too, not just the grey look
        const label = input.nextElementSibling;
        const note = label.querySelector('.visually-hidden');
        if (note) note.remove();
        if (!available) {
          const span = document.createElement('span');
          span.className = 'visually-hidden';
          span.textContent = ` (${labels.soldOut})`;
          label.appendChild(span);
        }
      });
    });
  }

  function renderVariant() {
    // Price
    const price = variant ? variant.price : product.price;
    const compare = variant ? variant.compare_at_price : product.compare_at_price;
    ui.priceNow.textContent = formatMoney(price);
    const onSale = compare && compare > price;
    ui.priceWas.hidden = !onSale;
    ui.priceWas.textContent = onSale ? formatMoney(compare) : '';

    // Image: variant image, else the product's featured image
    const src = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;
    if (src) {
      ui.image.src = sizedImage(src, 600);
      ui.image.srcset = [400, 600, 800, 1000].map((w) => `${sizedImage(src, w)} ${w}w`).join(', ');
      ui.image.sizes = '(min-width: 750px) 360px, 40vw';
      ui.image.alt = (variant && variant.featured_image && variant.featured_image.alt) || product.title;
      ui.image.hidden = false;
    } else {
      ui.image.hidden = true;
    }

    // Button state
    let label = labels.add;
    let locked = false;
    if (!variant) {
      label = labels.unavailable;
      locked = true;
    } else if (!variant.available) {
      label = labels.soldOut;
      locked = true;
    }
    ui.addLabel.textContent = label;
    ui.add.dataset.locked = String(locked);
    ui.add.disabled = locked;

    updateAvailability();
    showError(ui.error, '');
  }

  function populate(data, button) {
    product = data;
    variant = product.variants.find((v) => v.available) || product.variants[0] || null;

    ui.title.textContent = product.title;
    const bn = button.dataset.bnName || '';
    ui.bn.textContent = bn;
    ui.bn.hidden = !bn;
    ui.details.href = button.dataset.url || `${root}products/${product.handle}`;
    ui.qty.value = 1;
    ui.minus.setAttribute('aria-label', labels.decrease.replace('__PRODUCT__', product.title));
    ui.plus.setAttribute('aria-label', labels.increase.replace('__PRODUCT__', product.title));

    renderOptions();
    renderVariant();
  }

  /* ---------- Open / close ---------- */
  function openSheet() {
    document.body.classList.add('overflow-hidden');
    dialog.showModal();
    // Focus the first choice rather than the close button
    const first = ui.options.querySelector('input:checked') || ui.add;
    if (first) first.focus({ preventScroll: true });
  }

  function closeSheet() {
    dialog.close();
  }

  dialog.addEventListener('close', () => {
    // Keep the scroll lock when Dawn's cart drawer opens right after (it releases it on close)
    if (!keepScrollLock) document.body.classList.remove('overflow-hidden');
    keepScrollLock = false;
  });

  // Tap on the dimmed backdrop closes the sheet
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeSheet();
  });
  dialog.querySelector('[data-bd-close]').addEventListener('click', closeSheet);

  ui.options.addEventListener('change', () => {
    variant = findVariant(selectedValues());
    renderVariant();
  });

  dialog.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty]');
    if (!step) return;
    const next = Math.max(1, (parseInt(ui.qty.value, 10) || 1) + Number(step.dataset.qty));
    ui.qty.value = next;
  });

  ui.qty.addEventListener('change', () => {
    ui.qty.value = Math.max(1, parseInt(ui.qty.value, 10) || 1);
  });

  ui.add.addEventListener('click', () => {
    if (!variant || !variant.available) return;
    addToCart(variant.id, Math.max(1, parseInt(ui.qty.value, 10) || 1), ui.add, ui.error);
  });

  /* ---------- Card buttons (event delegation covers filtered / paginated grids) ---------- */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-bd-quick-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    trigger = button;
    const errorTarget = button.parentElement.querySelector('.bd-qa__error');

    if (button.dataset.single === 'true') {
      addToCart(button.dataset.variantId, 1, button, errorTarget);
      return;
    }

    setBusy(button, true);
    showError(errorTarget, '');
    try {
      const data = await fetchProduct(button.dataset.handle);
      populate(data, button);
      openSheet();
    } catch (error) {
      console.error(error);
      showError(errorTarget, labels.error);
    } finally {
      setBusy(button, false);
    }
  });
})();
